import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import styles from './CallToActionButtonDownload.module.css';
import PropTypes from 'prop-types';
import Link from './Link.js';
import urlJoinParameters from '../utils/urlJoinParameters.js';

const CallToActionButtonDownload = ({ children }) => {
  const { callToActionButtonDownloadText, articleLink, __source, tpcc } =
    useSearchParamOrDefaultProps();

  const to = urlJoinParameters(articleLink, { __source, tpcc });

  return (
    <div className={styles.callToActionButtonDownloadWrapper}>
      <Link to={to}>
        {children}
        {callToActionButtonDownloadText}
      </Link>
    </div>
  );
};

CallToActionButtonDownload.displayName = 'CallToActionButtonDownload';

CallToActionButtonDownload.defaultProps = {
  children: null,
};

CallToActionButtonDownload.propTypes = {
  children: PropTypes.node,
};

export default CallToActionButtonDownload;
